// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js?minimize!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6dd39339!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConfigResource.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("e13fe516", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6dd39339!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/user/ConfigResource.vue
// module id = 1138
// module chunks = 2